export default __webpack_public_path__ + "static/media/UI.e42fc17b.png";